import request from '../utils/request';

// 店铺访问统计API
export const storeVisitStatisticsApi = {
  // 根据ID查询店铺访问统计
  getStoreVisitStatisticsById: (id) => {
    return request({
      url: `/store-visit-statistics/${id}`,
      method: 'get'
    });
  },

  // 查询店铺访问统计列表
  listStoreVisitStatistics: (params) => {
    return request({
      url: '/store-visit-statistics/list',
      method: 'get',
      params
    });
  },

  // 分页查询店铺访问统计
  pageStoreVisitStatistics: (params) => {
    return request({
      url: '/store-visit-statistics/page',
      method: 'get',
      params: {
        page: params.page || 1,
        pageSize: params.pageSize || 10,
        startTime: params.startTime,
        endTime: params.endTime,
        sortField: params.sortField || 'create_time',
        sortOrder: params.sortOrder || 'desc'
      }
    });
  },

  // 根据ID删除店铺访问统计
  deleteStoreVisitStatisticsById: (id) => {
    return request({
      url: `/store-visit-statistics/${id}`,
      method: 'delete'
    });
  },

  // 根据状态统计店铺访问统计数量
  countStoreVisitStatisticsByStatus: (status) => {
    return request({
      url: '/store-visit-statistics/count',
      method: 'get',
      params: { status }
    });
  }
};
